import { baseApi } from "./baseApi";
import { Response } from "@interfaces/response";
import { NotificationsPage, NotificationSummary } from "@interfaces/notification";

const notificationsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSummary: build.query<NotificationSummary, void>({
            query: () => ({ url: "notificaciones/summary" }),
            transformResponse: (response: Response<NotificationSummary>) => response.data,
            providesTags: ["NotificationsSummary"],
        }),
        getNotifications: build.query<NotificationsPage, string>({
            query: (params) => ({ url: `notificaciones?${params}` }),
            transformResponse: (response: Response<NotificationsPage>) => response.data,
            providesTags: ["NotificationsList"],
        }),
        markRead: build.mutation<void, number>({
            query: (id) => ({ url: `notificaciones/${id}/read`, method: "POST" }),
            invalidatesTags: ["NotificationsSummary", "NotificationsList"],
        }),
        markSeen: build.mutation<{ updated: number }, void>({
            query: () => ({ url: "notificaciones/seen", method: "PATCH" }),
            transformResponse: (response: Response<{ updated: number }>) => response.data,
            invalidatesTags: ["NotificationsSummary"],
        }),
        markAllRead: build.mutation<{ updated: number }, void>({
            query: () => ({ url: "notificaciones/read-all", method: "POST" }),
            transformResponse: (response: Response<{ updated: number }>) => response.data,
            invalidatesTags: ["NotificationsSummary", "NotificationsList"],
        }),
    }),
});

export const {
    useGetSummaryQuery,
    useLazyGetNotificationsQuery,
    useMarkReadMutation,
    useMarkSeenMutation,
    useMarkAllReadMutation,
} = notificationsApi;
